<template>
  <div class="container my-con z-flex">
    <myLeftCom :activeMenu="0"></myLeftCom>
    <div class="my-con-main">
      <el-form class="form" :model="form" label-width="100px">
        <el-form-item class="form-item z-flex avatar-item" label="头像" prop="avatar">
          <div class="avatar-wrap">
            <el-avatar class="avatar" icon="el-icon-user-solid" :size="100" :src="vuex_user.avatar || 'https://img0.baidu.com/it/u=2421304583,2097332188&fm=253&fmt=auto&app=138&f=JPEG?w=751&h=500'"></el-avatar>
            <div class="edit z-flex z-flex-center" @click="showDialogEditAvatar">修改头像</div>
          </div>
        </el-form-item>
        <el-form-item class="form-item z-flex" label="昵称" prop="nickname">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>
        <el-form-item class="form-item z-flex" label="个人简介" prop="introduce">
          <el-input type="textarea" :rows="6" :maxlength="150" show-word-limit resize="none" v-model="form.introduce"></el-input>
        </el-form-item>
        <el-form-item class="form-item z-flex" label="密码" prop="password">
          <el-input v-model="form.password" show-password></el-input>
        </el-form-item>
        <el-form-item class="form-item z-flex" label="新密码" prop="passwordNew">
          <el-input v-model="form.passwordNew" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" round @click="save">确认修改</el-button>
        </el-form-item>
        <avatarCom ref="avatarCom"></avatarCom>
      </el-form>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import avatarCom from "@/components/avatarCom";
export default {
  components: {
	  avatarCom
  },
  data() {
    return {
      form:{
        avatar:'',
        nickname:'',
        introduce:'',
        password:'',
        passwordNew:'',
      },
      avatarUrl:'https://img0.baidu.com/it/u=2421304583,2097332188&fm=253&fmt=auto&app=138&f=JPEG?w=751&h=500',
    };
  },
  watch:{
    
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  mounted() {
    this.$axios.api.getUserInfo({}, (res) => {
      if (res.code == 200) {
        this.form.nickname = res.data.nickname;
        this.form.introduce = res.data.introduce;
      }
    });
  },
  created() {
    
  },
  methods: {
    ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
    editAvatar(){

    },
    onAvatarCrop(){

    },
    showDialogEditAvatar(){
      this.$refs.avatarCom.dialogEditAvatar = true;
    },
    // 保存表单
    save() {
      if (this.form.nickname == '') {
        return this.$message.error("昵称不能为空！");
      }
      if (this.form.password != '' && this.form.passwordNew == '') {
        return this.$message.error("新密码不能为空！");
      }
      if (this.form.password == '' && this.form.passwordNew != '') {
        return this.$message.error("密码不能为空！");
      }
      this.form.avatar = this.vuex_user.avatar;
      this.$axios.api.updateUserInfo(this.form, (res) => {
        if (res.code == 200) {
          this.vuex_user.username = this.form.nickname;
          this.vuexUserLogin(this.vuex_user);
          this.form.password = '';
          this.form.passwordNew = '';
          this.$message.success("修改成功！");
        } else {
          this.$message.error(res.msg);
        }
      });

    },
  }
};
</script>

<style lang="scss" scoped>
.form{
  width: 680px;
  margin: 50px auto 0;
  ::v-deep .form-item{
    .el-form-item__content{
      flex: 1;
      margin-left: 0!important;
    }
  }
}
.avatar-wrap{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  .edit{
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,.5);
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    display: none;
  }
  &:hover{
    .edit{
      display:flex;
    }
  }
}
</style>
